
import React from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { message, Icon, Pagination, Table } from 'antd';
import moment from 'moment';
import { CHINESE, ENGLISH, PARTICIPANT_STATUS } from '../../utils/constants';
import ControlButton from '../ControlButton';
import MeetingModal from '../MeetingModal';
import StopMeeting from '../StopMeeting';
import ExtendCMMAMeeting from '../ExtendCMMAMeeting';
import LayoutSetting from '../LayoutSetting';
import RotationSetting from '../RotationSetting';
import AddRoom from '../AddRoom';
import Dial from '../Dial';
import SubtitleMinutes from '../SubtitleMinutes';
import MsgSetting from '../MsgSetting';

class MeetingControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialPabel: false,
      showAddRoom: null,
      showExtend: false,
      showLayout: false,
      showRotation: false,
      showMessage: false,
      showSubtitleMinutes: false,
      showStopMeetingModal: false,
      text: '',
      duration: 10,
      participantId: '',
      layout_p: '',
      smType: 0
    };
    this.dispatch = props.dispatch;
  }

  //展开/隐藏拨号面板拨号面板
  showDialPanelHandle = () =>
    this.setState({ showDialPabel: !this.state.showDialPabel });

  // 显示/隐藏停止会议提示窗口
  toogleShowStopMeetingModal = () =>
    this.setState({ showStopMeetingModal: !this.state.showStopMeetingModal });

  // 结束会议时弹出提示，是否结束会议系统会议，如果点击否，则只结束视频会议
  stopCMMAMeeting = () => {
    this.toogleShowStopMeetingModal();
    this.dispatch({ type: 'meetingControl/stopCMMAMeeting' });
  };

  stopMeeting = () => this.dispatch({ type: 'meetingControl/stopMeeting' });

  // 结束会议时弹出提示，是否结束会议系统会议，如果点击是，则同时结束会议系统会议
  stopAll = () => {
    this.stopMeeting();
    this.stopCMMAMeeting();
  };

  startNow = () => this.dispatch({ type: 'meetingControl/startNow' });

  toggleReconnectAuto = () => this.dispatch({ type: 'meetingControl/toggleReconnectAuto' });

  toggleMuteAll = () => this.dispatch({ type: 'meetingControl/toggleMuteAll' });

  toggleLock = () => this.dispatch({ type: 'meetingControl/toggleLock' });

  extend = num => {
    this.dispatch({ type: 'meetingControl/extendCmma', extend: num });
    this.hideExtend();
  };

  onCall = number => {
    const {
      meetingControl: { participantList = [] },
      intl
    } = this.props;
    //检查当前拨打的号码是否重复
    const checDuplicate = participantList.some(p => p.address === number && p.removed === 0);
    if (checDuplicate) {
      message.warn(intl.formatMessage({ id: 'mc_msg_duplicate_number' }));
      return;
    }
    this.dispatch({ type: 'meetingControl/callNumber', number });
    this.showDialPanelHandle();
  };

  createSubtitleMinutes = (newAsr) => {
    const { smType } = this.state;
    this.dispatch({ type: 'meetingControl/createSubtitleMinutesOne', smType, newAsr })
    this.hideSubtitleMinutes();
  }

  hideSubtitleMinutes = () => {
    this.setState({ showSubtitleMinutes: false })
  }

  setMain = participantId =>
    this.dispatch({ type: 'meetingControl/setMain', participantId });

  toggleSetSpeaker = participantId =>
    this.dispatch({ type: 'meetingControl/toggleSetSpeaker', participantId });

  toggleAudioMuted = participantId => {
    this.dispatch({ type: 'meetingControl/toggleAudioMuted', participantId });
  };

  toggleReconnect = address => {
    const {
      meetingControl: { participants = [] },
      intl
    } = this.props;
    const checDuplicate = participants.some(p => {
      const { currentAddress = '' } = p.currentTerminal || {};
      return currentAddress === address
    });
    if (checDuplicate) {
      message.warn(intl.formatMessage({ id: 'mc_msg_duplicate_number' }));
      return;
    }
    this.dispatch({ type: 'meetingControl/toggleReconnect', address });
  };

  toggleVideoMuted = participantId =>
    this.dispatch({ type: 'meetingControl/toggleVideoMuted', participantId });

  removeParticipant = (address, participantId) =>
    this.dispatch({ type: 'meetingControl/removeParticipant', address, participantId });

  //控制添加会议室，修改布局，修改轮询设置的弹出框
  showAddRoom = () => {
    this.dispatch({ type: 'meetingControl/getAllCMMARooms' });
    this.setState({ showAddRoom: true });
  };

  hideAddRoom = () => {
    this.setState({ showAddRoom: false });
    this.dispatch({ type: 'meetingControl/update', CMMARooms: [] });
  };

  addonRoom = roomIds => {
    const { intl,
      meetingControl: { participantList = [], allDevice = [] }
    } = this.props;
    if (roomIds.length === 0) {
      message.warn(intl.formatMessage({ id: 'mc_msg_at_least_one' }));
      return;
    } else {
      const dupAddr = [];
      roomIds.split(',').forEach(rid=>{
        const dev = allDevice.find(ad=>ad.cmmaRoomId==rid);
        if (dev) {
          const {primaryAddress} = dev;
          const checDuplicate = participantList.some(p => p.address === primaryAddress && p.removed === 0);
          if (checDuplicate) {
            dupAddr.push(primaryAddress)
          }
        }
      });
      if (dupAddr.length > 0) {
        message.warn(intl.formatMessage({ id: 'mc_msg_duplicate_number' }));
        return;
      }
    }
    this.dispatch({ type: 'meetingControl/addonroom', roomIds });
    this.hideAddRoom();
  };

  showExtend = () => this.setState({ showExtend: true });

  hideExtend = () => this.setState({ showExtend: false });

  showLayout = (participantId, layout_p) =>
    this.setState({ showLayout: true, participantId, layout_p });

  hideLayout = () =>
    this.setState({ showLayout: false, participantId: '', layout_p: '' });

  showRotation = () => this.setState({ showRotation: true });

  hideRotation = () => this.setState({ showRotation: false });

  showMessage = () => this.setState({ showMessage: true });

  hideMessage = () =>
    this.setState({ showMessage: false, text: '', duration: 10 });

  toggleSubtitleMinutes = (smType, asr) => {
    // type: 0-会议字幕 1-会议纪要
    const {showSubtitle, showMinutes} = asr;
    if (!showSubtitle && !showMinutes) {
      // 两个功能都没有打开
      this.setState({ showSubtitleMinutes: true, smType })
    } else if(
      (showSubtitle && smType === 0) ||
      (showMinutes && smType === 1)
    ) {
      // 关闭其中一个功能
      this.dispatch({ type: 'meetingControl/dropSubtitleMinutes', smType, asr })
    } else {
      // 追加打开其中一个功能
      this.dispatch({ type: 'meetingControl/createSubtitleMinutesTwo', smType, asr })
    }
  }

  render() {
    const { meetingControl, intl } = this.props;
    const {
      meeting = {},
      conference = {},
      participants = [],
      participantList,
      asrParticipant = {},
      meetingCtrl: { joinPwd }
    } = meetingControl;
    const {
      id: conferenceId,
      layout,
      startAt = 0,
      durationInMinutes = 0,
      progressInMinutes = 0,
      callNumber = '',
      muteAll,
      locked,
      autoReconnect
    } = conference;

    //构造表格数据
    const columns = [
      {
        title: intl.formatMessage({ id: 'mc_table_room' }),
        key: 'name',
        render:record => {
          return intl.locale === ENGLISH ? record.nameEn:record.name;
        }
      },
      {
        title: intl.formatMessage({ id: 'mc_table_region' }),
        dataIndex: 'zone',
        key: 'zone'
      },
      {
        title: intl.formatMessage({ id: 'mc_table_terminal' }),
        dataIndex: 'deviceName',
        key: 'deviceName'
      },
      {
        title: intl.formatMessage({ id: 'mc_table_number' }),
        width: 250,
        dataIndex: 'num',
        key: 'num'
      },
      {
        title: intl.formatMessage({ id: 'mc_table_status' }),
        dataIndex: 'state',
        key: 'state',
        width: 250,
        render: state => {
          switch (state) {
            case PARTICIPANT_STATUS.connected:
              return (
                <span>
                  <FormattedMessage id="mc_status_connected" />
                  <span className="state-dot dot-green" />
                </span>
              );
            case PARTICIPANT_STATUS.ringing:
              return (
                <span>
                  <FormattedMessage id="mc_status_ringing" />
                  <img
                    className="ringing-img"
                    src={require('../../assets/ringing.gif')}
                    alt="ringing"
                  />
                </span>
              );
            default:
              return (
                <span>
                  <FormattedMessage id="mc_status_unknown" />
                  <span className="state-dot dot-red" />
                </span>
              );
          }
        }
      },
      {
        title: intl.formatMessage({ id: 'mc_table_option' }),
        key: 'action',
        width: 250,
        render: record => (
          <span className={'row-operate'}>
            {
              record.state === PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-main"
                selected={!!record.main}
                disabled={!!record.main}
                onClick={() => this.setMain(record.participantId)}
                title={intl.formatMessage({ id: 'mc_btn_main' })}
              />
            }
            {
              record.state === PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-laba"
                selected={!!record.speaker}
                disabled={!!record.main}
                onClick={() => this.toggleSetSpeaker(record.participantId)}
                title={intl.formatMessage({ id: 'mc_btn_speaking' })}
              />
            }
            {
              record.state === PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-video-control"
                selected={!!record.videoMuted}
                onClick={() => this.toggleVideoMuted(record.participantId)}
                title={intl.formatMessage({ id: 'mc_btn_video' })}
              />
            }
            {
              record.state === PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-microphone_off"
                selected={!!record.audioMuted}
                onClick={() => this.toggleAudioMuted(record.participantId)}
                title={intl.formatMessage({ id: 'mc_btn_audio' })}
              />
            }
            {
              record.state === PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-fenping1"
                selected={false}
                onClick={() =>
                  this.showLayout(record.participantId, record.layout)
                }
                title={intl.formatMessage({ id: 'mc_btn_layout' })}
              />
            }
            {
              record.state !== PARTICIPANT_STATUS.connected &&
              <ControlButton
                icon="icon-reload"
                onClick={() =>
                  this.toggleReconnect(record.num)
                }
                title={intl.formatMessage({ id: 'mc_btn_redial' })}
              />
            }
            <ControlButton
              icon="icon-phone-hangup"
              defaultColor="red"
              disabled={!!record.main}
              onClick={() => this.removeParticipant(record.num, record.participantId)}
              title={intl.formatMessage({ id: 'mc_btn_hang_up' })}
            />
          </span>
        )
      }
    ];

    // 过滤参会人员列表，并按照终端状态排序
    let showParticipants = participantList.filter(p=>p.removed === 0);
    showParticipants.sort((p1, p2) => p1.state === p2.state);

    //遍历生成表格的数据源
    let dataSource = [];
    if (showParticipants.length > 0) {
      dataSource = showParticipants.map((p,i)=>{
        /**
         * 终端状态的逻辑4.8.1
         * 1.WS消息中是已连接的不做处理，直接显示
         * 2.WS消息中存在的终端地址，但不是已连接状态，显示为‘拨号中’
         * 3.其他情况显示为‘未连接’
         */
        let pState = PARTICIPANT_STATUS.unknown;
        if (p.state === PARTICIPANT_STATUS.connected) {
          pState = p.state
        } else {
          const checDuplicate = participants.some(pa => {
            const { currentAddress = '' } = pa.currentTerminal || {};
            return currentAddress === p.address
          });
          if (checDuplicate) {
            pState = PARTICIPANT_STATUS.ringing
          }
        }

        return {
          participantId: p.participantId || i,
          cmmaRoomId: p.cmmaRoomId,
          name: p.name,
          nameEn: p.nameEn,
          zone: p.region,
          deviceName: p.terminal,
          num: p.address,
          state: pState,
          main: !!p.main,
          speaker: !!p.speaker,
          videoMuted: !!p.videoMuted,
          audioMuted: !!p.audioMuted,
          layout: p.layout || ''
        }
      })
    }

    // window.console.log('dataSource', dataSource);

    //计算显示剩余时间
    const lastMinutes = durationInMinutes - progressInMinutes;
    //剩余时间小于15分钟时，显示延长提示
    const showExtend = lastMinutes <= 15;

    const showStartTime = moment(startAt).format('HH:mm');
    const showEndTIme = moment(startAt)
      .add(durationInMinutes, 'minutes')
      .format('HH:mm');

    const rotationOngoing = conference && conference.rotation && conference.rotation !== 0;

    return (
      <div className="cmma-container">
        <div className="meeting-info">
          <span className="meeting-title">
            <span className="meeting-name">{meeting && meeting.name}</span>
            {!!conferenceId &&
              showExtend && (
                <span className="extend">
                  <FormattedMessage
                    id="mc_extend_message1"
                    values={{ lastMinutes }}
                  />
                  <span className="extend-btn" onClick={this.showExtend}>
                    <FormattedMessage id="mc_extend" />
                  </span>
                  <FormattedMessage id="mc_extend_message2" />
                </span>
              )}
          </span>
        </div>
        <div className="operate">
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_start_now' })}
            defaultColor="blue"
            disabled={!!conferenceId}
            onClick={this.startNow}
          />
          <ControlButton
            icon={''}
            selected={!!autoReconnect}
            name={intl.formatMessage({ id: 'meeting_info_reconnect_auto' })}
            disabled={!conferenceId}
            onClick={this.toggleReconnectAuto}
          />
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_add' })}
            disabled={!conferenceId}
            onClick={this.showAddRoom}
          />
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_dial' })}
            disabled={!conferenceId}
            onClick={this.showDialPanelHandle}
          />
          <ControlButton
            icon={''}
            selected={!!muteAll}
            name={
              !!muteAll
                ? intl.formatMessage({ id: 'mc_btn_mute_all_cancel' })
                : intl.formatMessage({ id: 'mc_btn_mute_all' })
            }
            disabled={!conferenceId}
            onClick={this.toggleMuteAll}
          />
          <ControlButton
            icon={''}
            selected={!!locked}
            name={
              !!locked
                ? intl.formatMessage({ id: 'mc_btn_unlock' })
                : intl.formatMessage({ id: 'mc_btn_lock' })
            }
            disabled={!conferenceId}
            onClick={this.toggleLock}
          />
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_message' })}
            disabled={!conferenceId}
            onClick={this.showMessage}
          />
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_layout' })}
            disabled={!conferenceId}
            onClick={() => this.showLayout('', '')}
          />
          <ControlButton
            icon={''}
            selected={!!rotationOngoing}
            name={intl.formatMessage({ id: 'mc_btn_rotation' })}
            disabled={!conferenceId}
            onClick={this.showRotation}
          />
          <ControlButton
            icon={''}
            selected={!!asrParticipant.showSubtitle}
            name={intl.formatMessage({ id: 'mc_btn_subtitle' })}
            disabled={!conferenceId}
            onClick={() => this.toggleSubtitleMinutes(0, asrParticipant)}
          />
          <ControlButton
            icon={''}
            selected={!!asrParticipant.showMinutes}
            name={intl.formatMessage({ id: 'mc_btn_minute' })}
            disabled={!conferenceId}
            onClick={() => this.toggleSubtitleMinutes(1, asrParticipant)}
          />
          <ControlButton
            icon={''}
            name={intl.formatMessage({ id: 'mc_btn_hang_up' })}
            defaultColor="red"
            disabled={!conferenceId}
            onClick={this.toogleShowStopMeetingModal}
          />
        </div>
        <div className="meeting-info">
          <span className="meeting-params">
            {!!callNumber && (
              <span>
                <i className="iconfont icon-phone-control" />
                {callNumber}
              </span>
            )}
            {joinPwd !== '' && (
              <span>
                <i className="iconfont icon-mima1" />
                {joinPwd}
              </span>
            )}
            {participants.length > 0 && (
              <span>
                <i className="iconfont icon-renshu" />
                {participants.length}
              </span>
            )}
            {!!conferenceId && (
              <span>
                <i className="iconfont icon-solid-time" />
                {`${showStartTime} - ${showEndTIme}`}
              </span>
            )}
          </span>
        </div>
        <div className="participants-table">
          <Table
            rowKey={r => r.participantId}
            dataSource={dataSource}
            columns={columns}
          />
        </div>
        <MeetingModal
          visible={this.state.showStopMeetingModal}
          title={intl.formatMessage({ id: 'mc_btn_hang_up' })}
          onClose={this.toogleShowStopMeetingModal}
          content={
            <StopMeeting
              stopAll={this.stopAll}
              stopCMMAMeeting={this.stopCMMAMeeting}
            />
          }
        />
        <MeetingModal
          visible={this.state.showExtend}
          title={intl.formatMessage({ id: 'mc_extend' })}
          onClose={this.hideExtend}
          content={
            <ExtendCMMAMeeting
              visible={this.state.showExtend}
              onOk={this.extend}
              onClose={this.hideExtend}
            />
          }
        />
        <MeetingModal
          visible={this.state.showAddRoom}
          title={intl.formatMessage({ id: 'mc_label_room_select' })}
          onClose={this.hideAddRoom}
          content={
            <AddRoom
              visible={this.state.showAddRoom}
              onOk={this.addonRoom}
              onClose={this.hideAddRoom}
              intl={intl}
            />
          }
        />
        <MeetingModal
          visible={this.state.showDialPabel}
          title={intl.formatMessage({ id: 'mc_btn_dial' })}
          onClose={this.showDialPanelHandle}
          width={300}
          content={
            <Dial visible={this.state.showDialPabel} onCall={this.onCall} />
          }
        />
        <MeetingModal
          visible={this.state.showSubtitleMinutes}
          title={intl.formatMessage({
            id: `mc_btn_${this.state.smType>0?'minute':'subtitle'}`
          })}
          onClose={this.hideSubtitleMinutes}
          width={600}
          content={
            <SubtitleMinutes
              intl={intl}
              visible={this.state.showSubtitleMinutes}
              onSubmit={this.createSubtitleMinutes}
              onCancel={this.hideSubtitleMinutes}
            />
          }
        />
        <MeetingModal
          visible={this.state.showLayout}
          title={intl.formatMessage({ id: 'mc_label_layout_model' })}
          onClose={this.hideLayout}
          width={600}
          content={
            <LayoutSetting
              defaultLayout={
                this.state.participantId === '' ? layout : this.state.layout_p
              }
              onChange={layout => {
                this.dispatch({
                  type: 'meetingControl/changeLayout',
                  layout,
                  participantId: this.state.participantId
                });
              }}
              visible={this.state.showLayout}
              onClose={this.hideLayout}
            />
          }
        />
        <MeetingModal
          intl={intl}
          visible={this.state.showRotation}
          onClose={this.hideRotation}
          width={
            rotationOngoing
              ? 400
              : 480
          }
          title={
            rotationOngoing
              ? intl.formatMessage({ id: 'mc_label_stop_rotation' })
              : intl.formatMessage({ id: 'mc_label_rotation_setting' })
          }
          content={
            <RotationSetting
              participantList={participantList}
              ongoing={rotationOngoing}
              dispatch={this.dispatch}
              visible={this.state.showRotation}
              onClose={this.hideRotation}
            />
          }
        />
        <MeetingModal
          visible={this.state.showMessage}
          onClose={this.hideMessage}
          title={intl.formatMessage({ id: 'cmma_msg_title' })}
          width={500}
          content={
            <MsgSetting
              dispatch={this.dispatch}
              onClose={this.hideMessage}
              setData={data => this.setState({ ...data })}
              params={{ text: this.state.text, duration: this.state.duration }}
            />
          }
        />
      </div>
    );
  }
}

export default MeetingControl;



// WEBPACK FOOTER //
// ./src/components/meetingControl/MeetingControl.js